<template>
    <el-dialog :title="title" :visible="showflag" @close="closeDialog" :close-on-click-modal="false" fullscreen>
        <el-row style="width: 100%">
            <el-tabs type="card" v-model="card_tab" @tab-click="clickTab">
                <el-tab-pane :label="re.work_type" :name="'tab'+re.id" v-for="re in report_list" :key="re.id"></el-tab-pane>
            </el-tabs>
        </el-row>
        <el-empty description="差异报告缺失" v-if="ts_show ==1"></el-empty>
        <el-row style="width: 100%" v-if="ts_show ==0">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" style="text-align: center">
                        <span style="font-size: 22px;font-weight: bold">
                            抽检数据验证分析
                            <template v-if="report.is_parallel ==1">（并灌）</template>
                            <template v-else-if="report.is_parallel ==2">（串孔）</template>
                        </span>
                    </div>
                    <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                        <div class="el-table__body-wrapper is-scrolling-none">
                            <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                <tbody>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>工程名称：</span></div>
                                        </td>
                                        <td class="el-table__cell" colspan="5">
                                            <div class="cell"><span>{{report.unit_name}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>设备编号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.device_code}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>孔号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.hole_code}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_no}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>作业方式：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.work_type}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>通道号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.channel_no}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>单元：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.unit_code}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>孔序：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.hole_order}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>循环方式：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.circle_type}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>开始时间：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.begin_time}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>桩号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.pile_no}}</span></div>
                                        </td>
                                        
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>排序：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.order_index}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>孔口高程(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.hole_height}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>结束时间：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.end_time}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段长(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_length1}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段顶(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_top}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段底(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_bottom}}</span></div>
                                        </td>                                        
                                        <td class="el-table__cell is-right">
                                            <!-- <div class="cell"><span>纯灌时间：</span></div> -->
                                        </td>
                                        <td class="el-table__cell">
                                            <!-- <div class="cell"><span>{{report.grout_duration_str}}</span></div> -->
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>水灰比：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.water_ash}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>砂灰比：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.sand_ash}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压力设定(Mpa)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.pressure_set}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>水泥比重(g/cm3)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.water_mud_proportion}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>施工单位：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.construction_unit}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>监测单位：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.monitor_unit}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>砂比重(g/cm3)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.sand_proportion}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>涌水压力(Mpa)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.water_pressure}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>余浆量(L)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.grout_volume_throw}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>管容(L)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.piping_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>地下水位(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.groundwater_level}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span></span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span></span></div>
                                        </td>                                        
                                    </tr>
                                    <tr class="el-table-row" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>弃灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.ash_volume_throw}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>管道占灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.piping_ash_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>外加剂1(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.material1_total}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>外加剂2(Kg):</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.material2_total}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>备注：</span></div>
                                        </td>
                                        <td class="el-table__cell" colspan="7">
                                            <div class="cell">
                                                <el-input v-model="report.remark" @blur="updateRemark"></el-input>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition" style="margin-top: 20px">
                        <div class="el-table__body-wrapper is-scrolling-none">
                            <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                <tbody>
                                    <tr class="el-table__row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>注浆量(L)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.grout_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异注浆量(L)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{jiaoyan_report.grout_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异值：</span></div>
                                        </td>
                                        <td class="el-table__cell" v-if="grout_volume_cha == 0">
                                            <div class="cell"><span>{{(grout_volume_cha)}}</span></div>
                                        </td>
                                        <td class="el-table__cell" v-else style="background: #F56C6C">
                                            <div class="cell"><span>{{(grout_volume_cha)}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table__row" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>注灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.ash_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异注灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{jiaoyan_report.ash_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异值：</span></div>
                                        </td>
                                        <td class="el-table__cell" v-if="ash_volume_cha == 0">
                                            <div class="cell"><span>{{(ash_volume_cha)}}</span></div>
                                        </td>
                                        <td class="el-table__cell" v-else style="background: #F56C6C">
                                            <div class="cell"><span>{{(ash_volume_cha)}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table__row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>单位注灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.ash_volume_unit}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异单位注灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{jiaoyan_report.ash_volume_unit}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异值：</span></div>
                                        </td>
                                        <td class="el-table__cell" v-if="ash_volume_unit_cha == 0">
                                            <div class="cell"><span>{{(ash_volume_unit_cha)}}</span></div>
                                        </td>
                                        <td class="el-table__cell" v-else style="background: #F56C6C">
                                            <div class="cell"><span>{{(ash_volume_unit_cha)}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table__row el-table__row--striped" v-if="report.work_type_int ==2 || report.work_type_int ==3">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>透水率(Lu)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.permeable_rate}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异透水率(Lu)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{jiaoyan_report.permeable_rate}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>差异值：</span></div>
                                        </td>
                                        <td class="el-table__cell" v-if="permeable_rate_cha == 0">
                                            <div class="cell"><span>{{(permeable_rate_cha)}}</span></div>
                                        </td>
                                        <td class="el-table__cell" v-else style="background: #F56C6C">
                                            <div class="cell"><span>{{(permeable_rate_cha)}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table__row el-table__row--striped">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>最大压力差：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{pressure_cha_max}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>最小压力差：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{pressure_cha_min}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span></span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span></span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table__row el-table__row--striped">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>最大密度差：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{density_cha_max}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>最小密度差：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{density_cha_min}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span></span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span></span></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row style="width: 100%; height: 455px; margin-top: 20px;margin-left: 0;margin-right: 0;" :gutter="20" v-if="ts_show ==0">
            <el-col :span="12" style="padding-left: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                            <span class="title-bar"></span>
                        <span>作业采样数据</span>
                    </div>
                    <el-table :data="samplingList" border stripe height="370">
                        <el-table-column prop="sampling_time_str" label="时间" sortable="custom"></el-table-column>
                        <el-table-column prop="flow" label="流量(L/Min)" sortable="custom"></el-table-column>
                        <el-table-column prop="pressure" label="压力(Mpa)" sortable="custom"></el-table-column>
                        <el-table-column prop="density" label="密度(g/cm3)" sortable="custom"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量(L)" sortable="custom" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量(kg)" sortable="custom" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率(Lu)" sortable="custom" v-if="report.work_type_int ==2 || report.work_type_int ==3"></el-table-column>
                        <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
                    </el-table>
                </el-card>
            </el-col>
            <el-col :span="12" style="padding-right: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                            <span class="title-bar"></span>
                        <span>差异采样数据</span>
                    </div>
                    <el-table :data="jianyan_samplingList" border stripe height="370">
                        <el-table-column prop="sampling_time_str" label="时间" sortable="custom"></el-table-column>
                        <el-table-column prop="flow" label="流量(L/Min)" sortable="custom"></el-table-column>
                        <el-table-column prop="pressure" label="压力(Mpa)" sortable="custom"></el-table-column>
                        <el-table-column prop="density" label="密度(g/cm3)" sortable="custom"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量(L)" sortable="custom" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量(kg)" sortable="custom" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率(Lu)" sortable="custom" v-if="report.work_type_int ==2 || report.work_type_int ==3"></el-table-column>
                        <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-row style="width: 100%; height: 455px; margin-top: 20px;margin-left: 0;margin-right: 0;" v-if="ts_show ==0">
            <el-col :span="24" style="padding-right: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                            <span class="title-bar"></span>
                        <span>数据统计图</span>
                    </div>
                    <el-radio-group v-model="echarts_show" size="small" @input="changeEcharts">
                        <el-radio-button label="1">流量</el-radio-button>
                        <el-radio-button label="2">压力</el-radio-button>
                        <el-radio-button label="3">密度</el-radio-button>
                        <el-radio-button label="4">抬动</el-radio-button>
                    </el-radio-group>
                    <div class="echarts1" ref="verifyDiffChart"></div>
                </el-card>
            </el-col>
        </el-row>
        <el-row style="width: 100%; height: 250px; margin-top: 20px;margin-left: 0;margin-right: 0;" v-if="ts_show ==0">
            <el-col :span="24" style="padding-right: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                            <span class="title-bar"></span>
                        <span>处置结果</span>
                    </div>
                    <el-form ref="formValidate" :model="verify_model" label-width="120px">
                        <el-form-item label="数据处置结果：">
                            <el-radio-group v-model="verify_model.verify_result">
                                <el-radio v-for="item in enuObj('verify_result')" :key="'verify_result'+item.key" :label="item.key">{{item.title}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input type="textarea" :rows="4" v-model="verify_model.remark"></el-input>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <!-- <el-button type="primary" @click="doReCreate" size="medium" v-if="ts_show ==0">重新生成</el-button> -->
            <el-button type="primary" @click="exportPDF" size="medium" v-if="ts_show ==0">导出PDF</el-button>
            <!-- <el-button type="primary" @click="saveResult" size="medium" v-if="ts_show ==0">保存处置结果</el-button> -->
            <el-button @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { verifyCheckInfo, workReportList, saveVerifyResult, reCreateVerifyReport, exportVerifyReport } from '@/api/statistic'
import { updateReportRemark } from '@/api/workreport'
import { applyLineChartTheme } from '@/libs/lineChartTheme'

// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')

export default {
    name: "verifyDiffInfo",
    mixins: [editutil],
    props: {
        hole_id: {
            type: Number,
            default() {
                return 0;
            }
        },
        segment_no: {
            type: String,
            default() {
                return ""
            }
        },
        report_type: {
            type: Number,
            default() {
                return 4
            }
        },
        to_report_id: {
            type: Number,
            default() {
                return 0
            }
        },
    },
    data() {
        return {
            report: {
                work_type_int: 1
            },
            jiaoyan_report: {},
            samplingList: [],
            jianyan_samplingList: [],
            echarts_show: 0,
            line1: [],
            line2: [],
            line3: [],
            line4: [],
            line11: [],
            line21: [],
            line31: [],
            line41: [],
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['作业报告数据', '差异报告数据']
                },
                grid: {
                    left: '8%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    name:'',
                    type: 'value'
                },
                series: [
                    {
                        name: '作业报告数据',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '差异报告数据',
                        type: 'line',
                        data: []
                    }
                ]
            },
            enu_name: ['verify_result'],
            report_list: [],
            report_id: 0,
            card_tab: '',
            work_type_int: 1,
            work_type: '',
            grout_volume_cha: 0,
            ash_volume_cha: 0,
            ash_volume_unit_cha: 0,
            permeable_rate_cha: 0,
            pressure_cha_max: 0,
            pressure_cha_min: 0,
            density_cha_max: 0,
            density_cha_min: 0,
            verify_model: {
                verify_result: '1',
                remark: ''
            },
            ts_show: 0,
            chartInstance: null,
        };
    },
    watch: {
        showflag(val) {
            if (!val) {
                this.disposeChart()
            }
        }
    },
    beforeDestroy() {
        this.disposeChart()
    },
    methods: {
        disposeChart() {
            if (this.chartInstance) {
                this.chartInstance.dispose()
                this.chartInstance = null
            }
        },
        renderChart() {
            this.$nextTick(() => {
                const chartEl = this.$refs.verifyDiffChart
                if (!chartEl) return
                if (!this.chartInstance) {
                    this.chartInstance = echarts.init(chartEl)
                }
                this.chartInstance.setOption(applyLineChartTheme(this.option), true)
                this.chartInstance.resize()
            })
        },
        loadOtherData() {
            //加载其他内容， 可重写
            this.msgList = []
            this.report = {}
            this.jiaoyan_report = {}
            this.samplingList = []
            this.jianyan_samplingList = []
            this.grout_volume_cha = 0
            this.ash_volume_cha = 0
            this.ash_volume_unit_cha = 0
            this.permeable_rate_cha = 0
            this.echarts_show = 0
            this.line1 = []
            this.line2 = []
            this.line3 = []
            this.line4 = []
            this.line11 = []
            this.line21 = []
            this.line31 = []
            this.line41 = []
            this.ts_show = 0
            this.disposeChart()
            this.option.yAxis.name = ''
            this.option.series[0].name = ''
            this.option.series[0].data = []
            this.option.series[1].name = ''
            this.option.series[1].data = []
            this.option.xAxis.data = []
        },
        getModelData(){
            workReportList(this.hole_id, this.segment_no, this.report_type).then(res=>{
                if(res.code ==1){
                    this.report_list = res.data
                    if(this.to_report_id != 0){
                        this.report_id = this.to_report_id
                        this.card_tab = 'tab'+this.to_report_id
                    }else{
                        this.report_id = this.report_list[0].id
                        this.card_tab = 'tab'+this.report_list[0].id
                    }
                    this.verifyInfo()
                }else if(res.code == 990){
                    this.$msg("没有报告可以展示")
                    this.closeDialog()
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        verifyInfo(){
            verifyCheckInfo(this.report_id, this.report_type).then(res=>{
                if(res.code ==1){
                    this.ts_show = 0
                    this.report = res.data.zuoye_report
                    this.jiaoyan_report = res.data.jiaoyan_report
                    this.samplingList = res.data.zuoye_sampling
                    this.jianyan_samplingList = res.data.jiaoyan_sampling
                    this.grout_volume_cha = res.data.grout_volume_cha
                    this.ash_volume_cha = res.data.ash_volume_cha
                    this.ash_volume_unit_cha = res.data.ash_volume_unit_cha
                    this.permeable_rate_cha = res.data.permeable_rate_cha
                    this.pressure_cha_max = res.data.pressure_cha_max
                    this.pressure_cha_min = res.data.pressure_cha_min
                    this.density_cha_max = res.data.density_cha_max
                    this.density_cha_min = res.data.density_cha_min
                    this.line1 = res.data.line1
                    this.line2 = res.data.line2
                    this.line3 = res.data.line3
                    this.line4 = res.data.line4
                    this.line11 = res.data.line11
                    this.line21 = res.data.line21
                    this.line31 = res.data.line31
                    this.line41 = res.data.line41
                    this.option.xAxis.data = res.data.xAxis
                    this.echarts_show = '1'
                    this.$nextTick(() => {
                        this.changeEcharts('1')
                    })
                    if(this.$isNotNull(res.data.verifyResult)){
                        this.verify_model.verify_result = res.data.verifyResult.result+''
                        this.verify_model.remark = res.data.verifyResult.remark
                    }
                }else if(res.code == 990){
                    this.ts_show = 1
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        changeEcharts(e){
            this.option.series[0].name = '作业报告数据'
            this.option.series[1].name = '差异报告数据'
            if(e =='1'){
                this.option.yAxis.name = '流量(L/Min)'
                this.option.series[0].data = this.line1
                this.option.series[1].data = this.line11
            }else if(e=='2'){
                this.option.yAxis.name = '压力(Mpa)'
                this.option.series[0].data = this.line2
                this.option.series[1].data = this.line21
            }else if(e=='3'){
                this.option.yAxis.name = '密度(g/cm3)'
                this.option.series[0].data = this.line3
                this.option.series[1].data = this.line31
            }else if(e=='4'){
                this.option.yAxis.name = '抬动(um)'
                this.option.series[0].data = this.line4
                this.option.series[1].data = this.line41
            }
            this.renderChart()
        },
        clickTab(tab){
            this.card_tab = tab.name
            this.report_id = this.report_list[tab.index].id
            this.work_type_int = this.report_list[tab.index].work_type_int
            this.work_type = this.report_list[tab.index].work_type
            this.verifyInfo()
        },
        saveResult(){
            saveVerifyResult(this.report_type, this.report_id, this.hole_id, this.segment_no, this.verify_model.verify_result, this.verify_model.remark).then(res=>{
                if(res.code===1){
                    this.$msgs("保存成功！");
                    this.$emit("on-save-ok",{});
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        exportPDF(){
            const loading = this.$loading({
                lock: true,
                text: '正在导出...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exportVerifyReport(this.report_type, this.hole_id, this.segment_no).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        doReCreate(){
            reCreateVerifyReport(this.report.id, this.report_type).then(res=>{
                if(res.code == 1){
                    this.$msgs("已重新生成")
                    this.$emit("on-save-ok",{})
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        updateRemark(){
            updateReportRemark(this.report.id, this.report.remark).then(res=>{
                if(res.code != 1){
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>
<style lang="less" scoped>
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
    .echarts1{
        width: 100%;
        height: 340px;
        margin-top: 0;
    }
</style>